export const MY_ACTIVITY_TITLE = "My Activity";
export const EXPERTS_TITLE = "Experts";
export const AGENT_TOOLS_TITLE = "Agent Tools";
export const INDUSTRY_HUB_TITLE = "Industry Hub";
export const RESOURCES_TITLE = "Resources";
export const ACCOUNT_TITLE = "Account";
